import http from './http'

//  {params, 1,2,3} 后面数组为1  是post请求  2隐藏加载框 3是更换传输格式
 // {params, 1,2} 后面get 同时存在1和2 隐藏加载框
/**
 *  @parms resquest 请求地址 例如：
 *  @param '/testIp'代表vue-cil中config，index.js中配置的代理
 */
let resquest = ""

// let resquestapp = "/app"

// get请求
export default {
	
	/****************************首页**************/
	// 是否测评过
	adminTiGetQuISCode(params) {
	  return http.get(`${resquest}/admin/ti/get/question/ischecks`, params,1,2)
	},
	// 首页冲稳保
	appJihuaNumApi(params) {
	  return http.get(`${resquest}/app/jihua/num`, params,1,2)
	},
	
	
	/****************************首页**************/
	
	
	
	
	
	
	
	
	
	/******************************************筛选**********************************/

	// 不选
	baokaoTitleApi(params) {
	  return http.get(`${resquest}/baokao/title`, params,1,2)
	},
	/******************************************筛选**********************************/
	
	
	
	
	
	
	
	
	
	// 验证码
	GetSysPutCode(params) {
	  return http.post(`${resquest}/app/send/code`, params,3)
	},
	// 登录
	GetADDStuApi(params) {
	  return http.post(`${resquest}/app/add/stu`, params,3)
	},
	
	// 获取省份
	GetAppCityApi(params) {
	  return http.get(`${resquest}/app/city`, params,1,2)
	},
	// 获取批次
	GetAppBatchListApi(params) {
	  return http.get(`${resquest}/app/batch/list/lu`, params)
	},
	
	// 获取批次 0425新增
	GetAppBatchListPcApi(params) {
	  return http.get(`${resquest}/app/batch/list/pc`, params)
	},
	
	
	
	
	// 获取位次
	GetAppBranchApi(params) {
	  return http.get(`${resquest}/app/branch`, params,1,2)
	},
	
	// 提交基本信息
	GetAppAddUserApi(params) {
	  return http.post(`${resquest}/app/add/user`, params,3)
	},
	// 卡密激活
	GetAppCardApi(params) {
	  return http.get(`${resquest}/app/card`, params)
	},
	// 开设院校
	GetAppOpenSchoolApi(params) {
	  return http.get(`${resquest}/app/open/school`, params)
	},
	
	
	/****************************学校接口**************/
	// 筛选获取省份
	homeCityListApi(params) {
	  return http.get(`${resquest}/home/city/list`, params,1,2)
	},
	
	// 筛选获取省份 0425新增
	homeCityListShanApi(params) {
	  return http.get(`${resquest}/home/city/list/shan`, params,1,2)
	},
	// 学校列表
	homeSchoolListApi(params) {
	  return http.get(`${resquest}/home/school/list`, params,1,2)
	},
	// 学校详情
	homeSchoolInfoApi(params) {
	  return http.get(`${resquest}/home/school/info`, params)
	},
	//详情录取 获取默认年
	homeDeYearoApi(params) {
	  return http.get(`${resquest}/home/default/year`, params,1,2)
	},
	
	//详情录取 获取年
	homeBranchTypeApi(params) {
	  return http.get(`${resquest}/home/branch/type`, params,1,2)
	},
	
	//详情录取 获取批次
	appBatchLIstApi(params) {
	  return http.get(`${resquest}/app/batch/list`, params,1,2)
	},
	
	// 6.23新增
	// 招生计划获取年
	homeDJi(params) {
	  return http.get(`${resquest}/home/default/year/ji`, params,1,2)
	},
	//详情录取 获取年
	homeBranchTypeJiApi(params) {
	  return http.get(`${resquest}/home/branch/type/ji`, params,1,2)
	},
	
	
	
	
	//详情录取 获取录取数据
	appLuApi(params) {
	  return http.get(`${resquest}/app/lu`, params,1,2)
	},
	
	//详情录取 获取招生计划
	appYearApi(params) {
		console.log('params',params)
	  return http.get(`${resquest}/app/year`, params,1,2)
	},
	
	
	/****************************学校接口**************/
	
	/****************************专业**************/
	//专业列表
	homeMajorListApi(params) {
	  return http.get(`${resquest}/home/major/list`, params,1,2)
	},
	
	//专业列表详情
	homeMajorInfoApi(params) {
	  return http.get(`${resquest}/home/major/info`, params,1,2)
	},
	
	
	
	//职业列表
	homeOccListApi(params) {
	  return http.get(`${resquest}/home/occ/list`, params,1,2)
	},
	//职业列表详情
	homeOccInfoApi(params) {
	  return http.get(`${resquest}/home/occ/info`, params,1,2)
	},
	
	
	// 查批次线  获取年
	homeBatchYearApi(params) {
	  return http.get(`${resquest}/home/branch/year`, params,1)
	},
	
	// 查批次线  获取年20250425
	homeBatchYearTiApi(params) {
	  return http.get(`${resquest}/home/branch/year/ti`, params,1)
	},
	
	//查询批次线
	homeBatchListApi(params) {
	  return http.get(`${resquest}/home/batch/list`, params,1,2)
	},
	
	/****************************专业**************/
	
	
	/****************************一分一段**************/
	//查询批次线
	homeBranchListApi(params) {
	  return http.get(`${resquest}/home/branch/list`, params,)
	},
	
	
	//一分一段表 新政0425
	homeBranchListNewApi(params) {
	  return http.get(`${resquest}/home/branch/list/new`, params,)
	},
	/****************************一分一段**************/
	
	/****************************一分一段**************/
	//学科评估
	homeSchoolGradeApi(params) {
	  return http.get(`${resquest}/home/school/grade`, params,)
	},
	/****************************一分一段**************/
	
	
	
	
	
	/****************************提前批**************/
	// homeBatchYearApi获取年使用
	
	//提前批 获取类型
	appJihuaTiTypeApi(params) {
	  return http.get(`${resquest}/app/jihua/ti/type`, params,)
	},
	
	//提前批 获取类型  规划师跳转
	appJihuaTiTypePhoneApi(params) {
	  return http.get(`${resquest}/app/jihua/ti/type/phone`, params,)
	},
	
	//提前批-获取列表
	appJihuaTiApi(params) {
	  return http.get(`${resquest}/app/jihua/ti`, params,)
	},
	//提前批-获取列表规划师跳转过来
	appJihuaTiPhoneApi(params) {
	  return http.get(`${resquest}/app/jihua/ti/phone`, params,)
	},
	/****************************提前批**************/
	
	
	
  // 首页bannert
  GetHomeBanner(params) {
    return http.get(`${resquest}/home/banner`, params,1,2)
	// return http.get(`${resquest}/home/cord/url`, params,1,2)
	
  },
  // 首页  查询 录取结果
  appUserRecodInfoApi(params) {
    return http.get(`${resquest}/app/user/record/info`, params,1)
  },
  
  
  
  // 首页  推荐视频
  courseTypeListApi(params) {
    return http.get(`${resquest}/course/type/list`, params,1,2)
  },
  // 首页  推荐视频 类别
  courseTypeListOneApi(params) {
    return http.get(`${resquest}/course/type/list/one`, params,1,2)
  },
  // 首页  请求完类别 请求列表
  courseListApi(params) {
    return http.get(`${resquest}/course/list`, params,1,2)
  },
  
  /****************************填报页面**************/
  // 计划 列表
  getAppJihua(params) {
    return http.get(`${resquest}/app/jihua`, params,1,2)
  },
  // 计划  计划数
  getAppJihuaNum(params) {
    return http.get(`${resquest}/app/jihua/num`, params,1,2)
  },
  // 计划  我的志愿表
  getAppMyJihuaApi(params) {
    return http.get(`${resquest}/app/my/jihua`, params,1,2)
  },
  
  // 计划  保存我的志愿
  getAppMyAddJihuaApi(params) {
    return http.get(`${resquest}/app/my/add/jihua`, params,1,2)
  },
  
  // 计划  筛选 城市
  AppgetCityLibraryApi(params) {
    return http.get(`${resquest}/app/get/city/library`, params,1,2)
  },
  // 计划  筛选 专业
  AppgetMajorLibraryApi(params) {
    return http.get(`${resquest}/app/get/major/library`, params,1,2)
  },
  
  // 计划  我的志愿 保存志愿
  appMyAddJihuaApi(params) {
    return http.get(`${resquest}/app/my/add/jihua`, params,1,2)
  },
  
  // 计划  我的志愿 导出
  appOpenExportApi(params) {
    return http.post(`${resquest}/app/open/export?status=1&sort=2`, params,3)
  },
  
  // 计划  一键填报
  appJihuaBigDataApi(params) {
    return http.post(`${resquest}/app/jihua/big/data`, params,3)
  },
  
 
  
  /****************************填报页面**************/
  
  //获取我的信息
  appMyInfoApi(params) {
    return http.get(`${resquest}/app/my/info`, params,1,2)
  },
  


}
